// Methods
import { cutParamFromUrl } from './utils/cutParamFromUrl';
import { getSznaiidCookieOptions } from './utils/cookieUtils';
import { sendHit } from './utils/sendHit';

// Utils
import { debug } from './utils/debug.js';
import { COOKIE } from '@iva/utils';

// Constants
import { COOKIE_NAMES, PARAM_NAMES, ACTIONS, EVENTS } from '../config.js';

/**
 * Attempts to retrieve SZNAIID from URL.
 * @return {String | null} SZNAIID or null if no sznaiid in URL.
 */
export const getSznaiid = () => {
  debug({
    message: 'getting SZNAIID',
    state: 'running',
    sznaiid: {
      state: 'start',
    },
  });

  const sznaiid = cutParamFromUrl(window.location.href, PARAM_NAMES.SZNAIID);

  if (!sznaiid) {
    debug({
      state: 'running',
      message: 'did not find sznaiid in url',
      sznaiid: {
        state: 'done',
        error: 'no sznaiid in URL',
        sznaiid,
      },
    });
    return null;
  }

  debug({
    state: 'running',
    message: 'successfully retrieved "sznaiid"',
    sznaiid: {
      state: 'done',
      sznaiid,
    },
  });
  return sznaiid;
};

/**
 * Stores SZNAIID cookie
 * @param {String} sznaiid value from URL
 * @return {('sznaiid_notstored' | 'sznaiid_same' | 'sznaiid_different')} Action based on context in browser.
 */
export const storeSznaiid = (sznaiid, reason) => {
  let action = '';

  // get actual sznaiid
  const localSznaiidCookie = COOKIE.getCookie(COOKIE_NAMES.SZNAIID);

  if (!localSznaiidCookie) {
    debug('did not find SZNAIID cookie, creating new');
    sendHit(ACTIONS.SZNAIID.NOT_STORED);
    action = ACTIONS.SZNAIID.NOT_STORED;
  } else if (localSznaiidCookie === sznaiid) {
    debug('found SZNAIID cookie with same SZNAIID value, refreshing expiration date of cookie');
    sendHit(ACTIONS.SZNAIID.SAME);
    action = ACTIONS.SZNAIID.SAME;
  } else {
    debug('found SZNAIID cookie with different SZNAIID value, overwriting cookie');
    sendHit(ACTIONS.SZNAIID.DIFFERENT);
    action = ACTIONS.SZNAIID.DIFFERENT;
  }

  COOKIE.setCookie(COOKIE_NAMES.SZNAIID, sznaiid, getSznaiidCookieOptions());
  sendHit(reason, { sznaiid }, true);
  window.dispatchEvent(new CustomEvent(EVENTS.SZNAIID_STORED, { detail: sznaiid }));

  return action;
};
